import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';


import HelpComponentBasicHelp from '../helpitems/HelpComponentBasicHelp';
import HelpComponentLocalActivities from '../helpitems/HelpComponentLocalActivities';

import { LocalizationContext } from '../App';

const LoupeHelp = (props) => {

    const topic = props.topic;
    const showHelp = props.isOpen;
    const closeHelpDrawerCallback = props.closeDrawerCallback;
    
    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    });

    const isDesktopView = useMediaQuery({
        query: '(min-width: 900px)'
    });

    const isLargeDesktopView = useMediaQuery({
        query: '(min-width: 1440px)'
    });

    const getHelpComponent = (p) => {
        switch (p) {
            case '/':
                return <HelpComponentBasicHelp />;
            case '/activities-here':
                return <HelpComponentLocalActivities />;                           
            default:
                return <>...</>;
        }
    }


    return (
        <LocalizationContext.Consumer>

        { ({strings}) => (

            <React.Fragment key='drawer'>
                
                <Drawer
                    anchor={ isMobileView == true ? 'bottom' : 'bottom' }
                    onClose={() => closeHelpDrawerCallback(false)}
                    open={showHelp}>

                    <Paper className="helpdrawer padding" elevation={0} square> 

                        {getHelpComponent(topic)}

                      

                    </Paper>

                </Drawer>

            </React.Fragment>
        
        )}

        </LocalizationContext.Consumer>
    )

}
export default LoupeHelp;